export const FileTypes = {
    AnnualTaxSummary: 'AnnualTaxSummary',
    EndOfEmployment: 'EndOfEmployment',
    Payslip: 'Payslip',
    IncomeRecord: 'IncomeRecord',
    ExpenseRecord: 'ExpenseRecord',
    BankStatement: 'BankStatement',
    Spreadsheet: 'Spreadsheet',
    PensionsDocument: 'PensionsDocument',
    Other: 'Other',
    InterestCertificate: 'InterestCertificate',
    DividendVoucher: 'DividendVoucher',
    PaymentSchedule: 'PaymentSchedule',
    AnnualSummary: 'AnnualSummary',
    Certificate: 'Certificate',
    CompanyTaxableBenefitsSummary: 'CompanyTaxableBenefitsSummary',
    InvestmentSchemeCertificate: 'InvestmentSchemeCertificate',
    DraftReturn: 'DraftReturn',
    SubmittedReturn: 'SubmittedReturn',
    Image: 'Image',
    PreviousReturn: 'PreviousReturn',
    TaxSchedule: 'TaxSchedule',
    TaxSummary: 'TaxSummary',
    IdDocument: 'IdDocument',
    ProofOfAddress: 'ProofOfAddress',
    TaxRegistrationSubmission: 'TaxRegistrationSubmission',
    SocialSecurityNumberVerification: 'SocialSecurityNumberVerification',
    SocialSecurityAuthorisationForm: 'SocialSecurityAuthorisationForm',
    Logo: 'Logo',
    CharitableGiving: 'CharitableGiving',
    CapitalGainsReport: 'CapitalGainsReport',
    LabourDocument: 'LabourDocument',
    Deed: 'Deed',
    TaxOfficeRegistration: 'TaxOfficeRegistration',
    RegionalTaxDeclaration: 'RegionalTaxDeclaration',
    AnnualAccounts: 'AnnualAccounts',
    AccountingBooksLegalization: 'AccountingBooksLegalization',
    ApprovedAccountsDeposit: 'ApprovedAccountsDeposit',
    CompanyAgreement: 'CompanyAgreement',
    PeriodAccounts: 'PeriodAccounts',
    BookLegalizationJournal: 'BookLegalizationJournal',
    BookLegalizationInventoryAndAnnualAccounts: 'BookLegalizationInventoryAndAnnualAccounts',
    BookLegalizationMinutesBook: 'BookLegalizationMinutesBook',
    BookLegalizationShareholdersBook: 'BookLegalizationShareholdersBook',
    CompanyAccountsApprovalMeetingMinutes: 'CompanyAccountsApprovalMeetingMinutes',
    CompanyAccountsApprovalMinutesCertificate: 'CompanyAccountsApprovalMinutesCertificate',
    CompanyAccountsApprovalMeetingMinutesSigned: 'CompanyAccountsApprovalMeetingMinutesSigned',
    CompanyAccountsApprovalMinutesCertificateSigned: 'CompanyAccountsApprovalMinutesCertificateSigned',
    CompanyAccountsReports: 'CompanyAccountsReports',
    CompanyAnnualAccounts: 'CompanyAnnualAccounts',
    ProofOfFiling: 'ProofOfFiling',
    CompaniesHouseFilingInvoice: 'CompaniesHouseFilingInvoice',
} as const

export type FileTypesType = (typeof FileTypes)[keyof typeof FileTypes]

export const FileSubType = {
    DrivingExpenses: 'DrivingExpenses',
    CarRentOrLeasePayments: 'CarRentOrLeasePayments',
    MileageLog: 'MileageLog',
    NonDrivingExpenses: 'NonDrivingExpenses',
    CarPurchaseReceipt: 'CarPurchaseReceipt',
    IncomeTaxReturn: 'IncomeTaxReturn',
    VatReturn: 'VatReturn',
    WithholdingTaxDueRentForm: 'WithholdingTaxDueRentForm',
    WithholdingTaxDuePersonalIncomeForm: 'WithholdingTaxDuePersonalIncomeForm',
    WithholdingTaxDueInterestForm: 'WithholdingTaxDueInterestForm',
    EuVatForm: 'EuVatForm',
    IncomesExpensesServiceFile: 'IncomesExpensesServiceFile',
    KoinlyReport: 'KoinlyReport',
    /**
     * @deprecated: Not in use any more but kept for legacy reasons
     * @see WithholdingTaxDueRentForm, WithholdingTaxDuePersonalIncomeForm and WithholdingTaxDueInterestForm
     */
    WithholdingTaxReturn: 'WithholdingTaxReturn',
    WorkActivityRegistration: 'WorkActivityRegistration',
    WorkActivityCancellation: 'WorkActivityCancellation',
} as const

export type FileSubTypeTypes = (typeof FileSubType)[keyof typeof FileSubType]
